var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.theme, _vm.touch ? 'touch' : 'no-touch', _vm.fetching, _vm.roll, _vm.search, _vm.first],attrs:{"id":"app"}},[_c('AppHeader'),_c('scroll-holder',{attrs:{"container-class":"scroll-container","body-class":"scroll-body"}},[_c('router-view'),_c('AppFooter')],1),_c('div',{staticClass:"fixed-holder"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }